import React, { useState } from "react";

interface Props {
  title: string;
  text: string;
  disabledText?: string;
  isActive: boolean;
  isLoading?: boolean;
  onAction: () => void;
}

export const ActionButton: React.FC<Props> = ({
  title,
  isActive,
  onAction,
  text,
  disabledText,
  isLoading,
}) => {
  const [buttonPressed, setButtonPressed] = useState(false);
  const classes = ["dqm-tcui-action-button-container", "dqm-tcui-box"];

  const onTouchdown = (event: any) => {
    event.preventDefault();
    setButtonPressed(true);
    setTimeout(() => setButtonPressed(false), 500);
    onAction();
  };

  if (isLoading) {
    classes.push("dqm-tcui-action-button-container__loading");
  }
  if (!isActive) {
    classes.push("dqm-tcui-action-button-container__disabled");
  }
  if (buttonPressed) {
    classes.push("dqm-tcui-action-button-container__button_pressed");
  }

  return (
    <div className={classes.join(" ")}>
      <button
        className="dqm-tcui-action-button"
        onTouchStart={onTouchdown}
        onMouseDown={onTouchdown}
        disabled={!isActive || isLoading}
      >
        <span className="dqm-tcui-action-button__title">{title}</span>
        <span className="dqm-tcui-action-button__text">{text}</span>
      </button>
      {isActive ? null : (
        <div className="dqm-tcui-action-button__disabled_overlay">
          <div className="dqm-tcui-action-button__disabled_overlay__background"></div>
          <div className="dqm-tcui-action-button__disabled_overlay__text">
            {disabledText}
          </div>
        </div>
      )}
    </div>
  );
};
